import AuthForm from '../form';
import CenteredLayout from '../layouts/Centered';
import { LoaderButton } from '../../generic/Button';
import Text from '../../generic/Text';

type AccessGrantedProps = {
  orgTitle: string;
  isLoading: boolean;
  onCancelAccessRequest: () => void;
};

/**
 * Message displayed to users when they have fulfilled orgAccessRequest.
 * TODO: it's unclear when the user would land on onboarding while they already are in an org, so we should test if this is ever shown...
 *
 * @param {string} orgTitle - Title of the organization the user is trying to join.
 * @param {string} isLoading - State of network requests, so we can show the loader.
 * @param {string} onCancelAccessRequest - Function called which will cancel the user's access request.
 */
const AccessGranted = ({
  orgTitle,
  isLoading,
  onCancelAccessRequest,
}: AccessGrantedProps) => (
  <main className="fossa-auth">
    <CenteredLayout>
      <AuthForm.Container onSubmit={onCancelAccessRequest}>
        <AuthForm.Heading heading="You're In!" />
        <div className="margin-top-xl margin-bottom-xl">
          <Text>
            You&apos;ve been invited to join {orgTitle}. Check your email to get started.
          </Text>
        </div>
        <LoaderButton
          type="error"
          size="small"
          isDisabled={isLoading}
          isLoading={isLoading}
          onClick={onCancelAccessRequest}
          isFullWidth
        >
          Cancel Access Request
        </LoaderButton>
      </AuthForm.Container>
    </CenteredLayout>
  </main>
);

export default AccessGranted;
